// Exercise → muscle group mapping (mirrors backend EXERCISE_MUSCLE_MAP)
const EXERCISE_MUSCLES = {
  "squat": { primary: ["quads", "glutes"], secondary: ["hamstrings", "core"] },
  "back squat": { primary: ["quads", "glutes"], secondary: ["hamstrings", "core"] },
  "barbell back squat": { primary: ["quads", "glutes"], secondary: ["hamstrings", "core"] },
  "front squat": { primary: ["quads", "core"], secondary: ["glutes"] },
  "goblet squat": { primary: ["quads", "glutes"], secondary: ["core"] },
  "deadlift": { primary: ["hamstrings", "glutes", "lower_back"], secondary: ["core", "quads"] },
  "romanian deadlift": { primary: ["hamstrings", "glutes"], secondary: ["lower_back", "core"] },
  "rdl": { primary: ["hamstrings", "glutes"], secondary: ["lower_back", "core"] },
  "romanian deadlift (rdl)": { primary: ["hamstrings", "glutes"], secondary: ["lower_back", "core"] },
  "bench press": { primary: ["chest", "triceps"], secondary: ["shoulders"] },
  "incline bench press": { primary: ["chest", "shoulders"], secondary: ["triceps"] },
  "overhead press": { primary: ["shoulders", "triceps"], secondary: ["core"] },
  "military press": { primary: ["shoulders", "triceps"], secondary: ["core"] },
  "barbell row": { primary: ["upper_back", "biceps"], secondary: ["core"] },
  "bent over row": { primary: ["upper_back", "biceps"], secondary: ["core"] },
  "pull-up": { primary: ["upper_back", "biceps"], secondary: ["core"] },
  "chin-up": { primary: ["biceps", "upper_back"], secondary: ["core"] },
  "lat pulldown": { primary: ["upper_back", "biceps"], secondary: [] },
  "pushup": { primary: ["chest", "triceps"], secondary: ["shoulders", "core"] },
  "push-up": { primary: ["chest", "triceps"], secondary: ["shoulders", "core"] },
  "dip": { primary: ["chest", "triceps"], secondary: ["shoulders"] },
  "lunge": { primary: ["quads", "glutes"], secondary: ["hamstrings", "core"] },
  "bulgarian split squat": { primary: ["quads", "glutes"], secondary: ["hamstrings"] },
  "leg press": { primary: ["quads", "glutes"], secondary: ["hamstrings"] },
  "leg curl": { primary: ["hamstrings"], secondary: [] },
  "leg extension": { primary: ["quads"], secondary: [] },
  "hip thrust": { primary: ["glutes"], secondary: ["hamstrings", "core"] },
  "cable row": { primary: ["upper_back", "biceps"], secondary: ["core"] },
  "face pull": { primary: ["upper_back", "shoulders"], secondary: [] },
  "bicep curl": { primary: ["biceps"], secondary: [] },
  "dumbbell curl": { primary: ["biceps"], secondary: [] },
  "tricep extension": { primary: ["triceps"], secondary: [] },
  "skull crusher": { primary: ["triceps"], secondary: [] },
  "lateral raise": { primary: ["shoulders"], secondary: [] },
  "plank": { primary: ["core"], secondary: ["shoulders"] },
  "crunch": { primary: ["core"], secondary: [] },
  "calf raise": { primary: ["calves"], secondary: [] },
};

export function getMusclesForExercise(exerciseName) {
  const name = exerciseName.toLowerCase().trim();
  if (EXERCISE_MUSCLES[name]) return EXERCISE_MUSCLES[name];
  // Partial match
  for (const [key, muscles] of Object.entries(EXERCISE_MUSCLES)) {
    if (name.includes(key) || key.includes(name)) return muscles;
  }
  return { primary: ["core"], secondary: [] };
}

export default EXERCISE_MUSCLES;
